<template>
  <div>
    <div class="panel-heading">
      <h4 class="panel-title">Archived Orders</h4>
    </div>

    <div
      class="panel-body"
      style="display: block;"
    >
      <div class="row">
        <preDatatableComponent
          :removeAddButton="true"
          :removeWarehouseDeliverButton="true"
          :checkAlert="checkAlert"
          :tableData="tableData"
          :resetGetResults="resetGetResults"
          :resetGetResults2="resetGetResults2"
          :searchMe="searchMe"
          :pagination="pagination"
          :perPageFix="perPageFix"
          :filterTable="filterTable"
          :hideSelectingColumn="true"
        ></preDatatableComponent>
        <div class="col-xs-12">
          <div class="row text-center">
            <span
              id="test-editable"
              style="opacity:0"
            ></span>
          </div>
          <datatable
            v-if="!isMobile"
            :sortDir="tableData.sortDir"
            :columns="columns"
            :sortByColumn="sortByColumn"
            :searchOneCol="searchOneCol"
            :sortKey="sortKey"
            :sortOrders="sortOrders"
          >
            <tbody>
              <tr
                v-for="r in apiResults"
                :key="r.order_id"
              >
                <td>{{ r.theOrderID }}</td>
                <td>
                  <a
                    :href="r.product_url"
                    target="_blank"
                  >{{
                    r.product_url.replace(/http(s)?:\/\//, '').substr(0, 25) +
                      (r.product_url.length > 25 ? '...' : '')
                  }}</a>
                </td>
                <td>{{ r.product_name }}</td>
                <td>{{ r.quantity }}</td>
                <td>
                  <span v-if="r.country == 'USA'">
                    <flag iso="um" />
                  </span>
                  <span v-else-if="r.country == 'Turkey'">
                    <flag iso="tr" />
                  </span>
                  <span v-else-if="r.country == 'China'">
                    <flag iso="cn" />
                  </span>
                  <span v-else-if="r.country == 'German'">
                    <flag iso="de" />
                  </span>
                  <span v-else-if="r.country == 'UK'">
                    <flag iso="gb" />
                  </span>
                  &nbsp; {{ r.country }}
                </td>
                <td>{{ r.note }}</td>
                <td>
                  <span v-if="r.order_date != null">{{ r.order_date }}</span>
                  <span v-else>{{ r.created_at }}</span>
                </td>
                <router-link
                  :to="'/order-detail?id=' + r.order_id"
                  tag="td"
                  style="padding-left:0px; padding-right:5px"
                ><a tooltip="View Detail"><i class="material-icons">aspect_ratio</i></a></router-link>
                <td style="padding-left:0px; padding-right:3px">
                  <a
                    style="color:#424242"
                    tooltip="View Invoice"
                    @click="initInvDetail('modal_showApp', r.order_id)"
                  >
                    <i class="material-icons">assignment</i>
                  </a>
                </td>
              </tr>
              <tr id="no-result-row">
                <td
                  :colspan="columns.length"
                  class="text-center"
                >
                  <v-alert
                    type="error"
                    :value="alertValue"
                  >
                    No Results Found
                  </v-alert>
                </td>
              </tr>
            </tbody>
          </datatable>

          <mobile-datatable
            v-if="isMobile"
            :isOrder="true"
          >
            <tbody>
              <tr
                v-for="r in apiResults"
                :key="r.order_id"
              >
                <td>
                  {{ r.product_name }} , <br />
                  <a
                    :href="r.product_url"
                    target="_blank"
                  >{{
                    r.product_url.replace(/http(s)?:\/\//, '').substr(0, 25) +
                      (r.product_url.length > 25 ? '...' : '')
                  }}</a>
                  <br />
                  <span v-if="r.country == 'USA'">
                    <flag iso="um" />
                  </span>
                  <span v-else-if="r.country == 'Turkey'">
                    <flag iso="tr" />
                  </span>
                  <span v-else-if="r.country == 'China'">
                    <flag iso="cn" />
                  </span>
                  <span v-else-if="r.country == 'German'">
                    <flag iso="de" />
                  </span>
                  <span v-else-if="r.country == 'UK'">
                    <flag iso="gb" />
                  </span>
                  &nbsp; {{ r.country }} ,
                  <br />
                  Quantity : {{ r.quantity }}
                </td>
                <td>
                  <span v-if="r.order_date != null">{{ r.order_date }}</span>
                  <span v-else>{{ r.created_at }}</span>
                  <br />
                  <router-link
                    :to="'/order-detail?id=' + r.order_id"
                    tag="span"
                    style="display: inline-block; padding-left:0px; padding-right:3px"
                  ><a tooltip="Order Detail"><i class="material-icons">aspect_ratio</i></a></router-link>
                  <span style="padding-left:0px; padding-right:3px">
                    <a
                      style="color:#424242"
                      tooltip="View Invoice"
                      @click="initInvDetail('modal_showApp', r.order_id)"
                    >
                      <i class="material-icons">assignment</i>
                    </a>
                  </span>
                </td>
              </tr>
              <tr id="no-result-row">
                <td
                  colspan="2"
                  class="text-center"
                >
                  <v-alert
                    type="error"
                    :value="alertValue"
                  >
                    No Results Found
                  </v-alert>
                </td>
              </tr>
            </tbody>
          </mobile-datatable>

          <view-log-details
            :detialData="invoiceDetailData"
            :closeModal="closeModal"
            :companyData="companyData"
          ></view-log-details>

          <view-order-details
            :detialData="detialData"
            :closeModal="closeModal"
          ></view-order-details>

          <hr />
          <div class="row">
            <div class="col-xs-12 text-right">
              <paginate
                :page-count="pagination.lastPage"
                :page-range="2"
                :changePage="changePage"
                :container-class="'pagination'"
                :pagination="pagination"
                :page-class="'page-item'"
              >
              </paginate>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PaginationVue from '../Pagination.vue'
import preDatatableComponent from '../preDatatableComponent.vue'
import DatatableVue from '../Datatable.vue'
import viewOrderDetails from '../viewOrderDetails.vue'
import viewLogDetails from '../logs/viewLogDetails.vue'
import mobileDatatable from '../mobileDatatable'
import axios from 'axios'
import swal from 'sweetalert'

export default {
  components: {
    preDatatableComponent: preDatatableComponent,
    datatable: DatatableVue,
    paginate: PaginationVue,
    'view-order-details': viewOrderDetails,
    'view-log-details': viewLogDetails,
    'mobile-datatable': mobileDatatable
  },
  created() {
    this.getLoggedInUser()
  },
  mounted() {
    if (!this.loggedInUserData.is_staff) {
      this.getUser()
    }
    this.perPageFix()

    if (screen.width <= 600) {
      this.isMobile = true
    } else {
      this.isMobile = false
    }
  },
  $_veeValidate: {
    validator: 'new'
  },
  data() {
    let sortOrders = {}
    let columns = [
      { label: 'ID', sortable: true, searchable: true, name: 'theOrderID' },
      { label: 'Product URL', sortable: true, searchable: true, name: 'product_url' },
      { label: 'Product Name', sortable: true, searchable: true, name: 'product_name' },
      { label: 'quantity', sortable: true, searchable: true, name: 'quantity' },
      { label: 'Warehouse', sortable: true, searchable: true, name: 'country' },
      { label: 'Note', sortable: true, searchable: true, name: 'note' },
      { label: 'Order Date', sortable: true, searchable: true, name: 'order_date' }
    ]
    columns.forEach(column => {
      sortOrders[column.name] = -1
    })

    return {
      isMobile: false,
      loader: null,
      loading: false,
      dialog: false,
      url: 'api/archived_order',
      orderDetailUrl: 'api/show_order_detail',
      companyUrl: 'api/company_info',
      logDetailUrl: 'api/order_credit_log_transaction',
      rowIndex: '',
      alertValue: false,
      checkAlert: false,
      loggedInUserData: {},
      companyData: {
        company_name: '',
        company_address: '',
        company_email: ''
      },
      invoiceDetailData: {
        credit_log_transaction_id: '',
        credit_log_transaction_date: '',
        invoice_number: '',
        amount: '',
        created_at: '',
        full_name: '',
        email: '',
        address: '',
        quantity_charge: '',
        phone_number: '',
        product_name: '',
        quantity: '',
        item_price: '',
        tax: '',
        item_weight: '',
        internal_shipping_handling: '',
        kreenex_fee: '',
        delivery_price: '',
        insurance: '',
        description: ''
      },
      detialData: {
        order_id: '',
        full_name: '',
        email: '',
        phone_number: '',
        c_o_d: '',
        product_url: '',
        product_name: '',
        description: '',
        size: '',
        type: '',
        status: '',
        color: '',
        quantity: '',
        coupon: '',
        qrcode: '',
        barcode: '',
        delivery_type: '',
        item_weight: '',
        item_price: '',
        tax: '',
        internal_shipping_handling: '',
        kreenex_fee: '',
        delivery_price: '',
        insurance: '',
        total_amount: '',
        from_date: '',
        to_date: '',
        refund_reason: '',
        country: '',
        created_at: ''
      },
      btnsave: true,
      alreadyAnimated: false,
      prevSearchQuery: '',
      apiResults: [],
      detailResults: [],
      columns: columns,
      sortKey: 'updated_at',
      sortOrders: sortOrders,
      tableData: {
        per_page: 10,
        search: '',
        column: 'updated_at',
        sortDir: 'desc',
        searchOneCol: '',
        searchOneVal: '',
        from_date: '',
        to_date: ''
      },
      pagination: {
        lastPage: 1,
        currentPage: 1,
        total: 1,
        lastPageUrl: '',
        nextPageUrl: '',
        prevPageUrl: '',
        from: '',
        to: ''
      }
    }
  },

  methods: {
    modal(modal) {
      $('#' + modal).modal({ backdrop: 'static' })
    },

    closeModal(modal) {
      let theModal = $('#' + modal)
      theModal.modal('toggle')
    },

    initInvDetail(modal, id) {
      let token = localStorage.getItem('access_token')
      this.getCompanyData(token)
      axios
        .get(this.logDetailUrl + '/' + id, { headers: { Authorization: 'Bearer ' + token } })
        .then(response => {
          let data = response.data
          let detailResults = []
          detailResults = data.data

          this.invoiceDetailData.credit_log_transaction_date =
            detailResults[0].credit_log_transaction_date
          this.invoiceDetailData.credit_log_transaction_id =
            detailResults[0].credit_log_transaction_id
          this.invoiceDetailData.invoice_number = detailResults[0].invoice_number
          this.invoiceDetailData.amount = detailResults[0].amount
          this.invoiceDetailData.full_name = detailResults[0].full_name
          this.invoiceDetailData.email = detailResults[0].email
          this.invoiceDetailData.address = detailResults[0].address
          this.invoiceDetailData.phone_number = detailResults[0].phone_number
          this.invoiceDetailData.product_name = detailResults[0].product_name
          this.invoiceDetailData.quantity = detailResults[0].quantity
          this.invoiceDetailData.item_weight = detailResults[0].item_weight
          this.invoiceDetailData.item_price = detailResults[0].item_price
          this.invoiceDetailData.tax = detailResults[0].tax
          this.invoiceDetailData.internal_shipping_handling =
            detailResults[0].internal_shipping_handling
          this.invoiceDetailData.insurance = detailResults[0].insurance
          this.invoiceDetailData.kreenex_fee = detailResults[0].kreenex_fee
          this.invoiceDetailData.delivery_price = detailResults[0].delivery_price
          this.invoiceDetailData.quantity_charge = detailResults[0].quantity_charge
          this.invoiceDetailData.created_at = detailResults[0].created_at
          this.invoiceDetailData.description = detailResults[0].description
        })
      this.modal(modal)
    },

    getCompanyData(token) {
      axios
        .get(this.companyUrl, { headers: { Authorization: 'Bearer ' + token } })
        .then(response => {
          let data = response.data
          let companyResult = []
          companyResult = data.data

          this.companyData.company_name = companyResult.company_name
          this.companyData.company_address = companyResult.company_address
          this.companyData.company_email = companyResult.company_email
        })
    },

    getLoggedInUser() {
      this.loggedInUserData = JSON.parse(localStorage.getItem('user_data'))
    },

    getUser() {
      let token = localStorage.getItem('access_token')
      axios.get('api/me', { headers: { Authorization: 'Bearer ' + token } }).then(response => {
        localStorage.setItem('user_data', JSON.stringify(response.data))
      })
    },

    filterTable(fromDate, toDate) {
      this.tableData.from_date = fromDate
      this.tableData.to_date = toDate
      this.getResults()
    },

    getResults(url = this.url) {
      var token = localStorage.getItem('access_token')
      let theDatatable = document.querySelector('.the-datatable')
      let thePanel = document.querySelector('.panel-flat')

      if (theDatatable != null) {
        theDatatable.classList.add('slide-table-out')
        thePanel.style.overflowX = 'auto'
      }

      axios
        .get(url, { params: this.tableData, headers: { Authorization: 'Bearer ' + token } })
        .then(response => {
          let data = response.data
          this.apiResults = data.data.data

          if (this.apiResults.length === 0) {
            this.tableData.searchOneCol = ''
            this.tableData.searchOneVal = ''
            this.tableData.search = ''
            this.alertValue = true
          } else {
            this.alertValue = false
          }
          this.configPagination(data.data)
          theDatatable.classList.remove('slide-table-out')
          setTimeout(function () {
            thePanel.style.overflowX = 'auto'
          }, 0)
        })
    },

    resetGetResults() {
      this.tableData.searchOneCol = ''
      this.tableData.searchOneVal = ''
      this.tableData.search = ''
      this.sortKey = 'updated_at'
      this.tableData.sortDir = 'desc'
      this.tableData.column = 'updated_at'
      this.tableData.from_date = ''
      this.tableData.to_date = ''
      this.getResults()
    },

    resetGetResults2() {
      this.queryParameter = false
      this.tableData.searchOneCol = ''
      this.tableData.searchOneVal = ''
      this.tableData.search = ''
      this.sortKey = 'updated_at'
      this.tableData.sortDir = 'desc'
      this.tableData.column = 'updated_at'
      this.tableData.from_date = ''
      this.tableData.to_date = ''
      this.getResults()
    },

    perPageFix(perPage) {
      this.tableData.per_page = perPage
      this.getResults()
    },

    changePage(pageUrl) {
      this.url = pageUrl
      this.getResults()
    },

    initDetail(modal, id) {
      let token = localStorage.getItem('access_token')
      axios
        .get(this.orderDetailUrl + '/' + id, { headers: { Authorization: 'Bearer ' + token } })
        .then(response => {
          let data = response.data
          this.detailResults = data.data
          this.detialData = this.detailResults[0]
        })
      this.modal(modal)
    },

    searchMe(str) {
      this.tableData.searchOneCol = ''
      this.tableData.searchOneVal = ''
      if (str.trim() !== '') {
        this.tableData.search = str
        this.prevSearchQuery = str
        this.getResults()
      } else {
        swal({
          text: 'Type something to search!',
          icon: 'warning',
          dangerMode: true
        })
        if (this.prevSearchQuery !== '') {
          this.tableData.search = ''
          this.prevSearchQuery = ''
          this.getResults()
        }
      }
    },

    sortByColumn(str) {
      this.tableData.column = str
      this.tableData.sortKey = str
      this.tableData.sortDir = this.tableData.sortDir === 'desc' ? 'asc' : 'desc'
      this.getResults()
    },

    searchOneCol(columnName, str) {
      this.tableData.searchOneCol = columnName
      this.tableData.searchOneVal = str
      this.getResults()
    },

    configPagination(data) {
      this.pagination.lastPage = data.last_page
      this.pagination.currentPage = data.current_page
      this.pagination.total = data.total
      this.pagination.lastPageUrl = data.last_page_url
      this.pagination.nextPageUrl = data.next_page_url
      this.pagination.prevPageUrl = data.prev_page_url
      this.pagination.from = data.from
      this.pagination.to = data.to
    }
  }
}
</script>

<style>
.panel-heading {
  color: #006b8d;
  border-bottom: 2px solid #006b8d !important;
}

.panel-heading h4 {
  text-transform: uppercase;
  margin-left: -20px;
  padding-left: 10px;
  font-weight: 500;
}

.btn {
  transition: all 0.5s;
}

.col-xs-12 {
  padding-top: 10px;
  padding-bottom: 10px;
}

.page-stats {
  align-items: center;
  position: relative;
  top: -8px;
  margin-right: 5px;
}

@media screen and (max-width: 600px) {
  th {
    font-weight: bold;
    color: #273246;
    padding-left: 5px !important;
  }

  td {
    padding-left: 5px !important;
    padding-top: 10px !important;
    padding-bottom: 10px !important;
  }
}

a:hover {
  color: #03a9f4;
  position: relative;
}
a[tooltip]:hover:after {
  content: attr(tooltip);
  padding: 8px 12px;
  color: #ffffff;
  position: absolute;
  right: 80%;
  bottom: 150%;
  white-space: nowrap;
  z-index: 20;
  -moz-border-radius: 3px;
  -webkit-border-radius: 3px;
  border-radius: 3px;
  -moz-box-shadow: 0px 0px 2px #484b4e;
  -webkit-box-shadow: 0px 0px 2px #484b4e;
  box-shadow: 0px 0px 2px #484b4e;
  background-image: -moz-linear-gradient(top, #484b4e, #484b4e);
  background-image: -webkit-gradient(
    linear,
    left top,
    left bottom,
    color-stop(0, #484b4e),
    color-stop(1, #484b4e)
  );
  background-image: -webkit-linear-gradient(top, #484b4e, #484b4e);
  background-image: -moz-linear-gradient(top, #484b4e, #484b4e);
  background-image: -ms-linear-gradient(top, #484b4e, #484b4e);
  background-image: -o-linear-gradient(top, #484b4e, #484b4e);
}
</style>



// WEBPACK FOOTER //
// src/components/customer/archivedOrder.vue